import { render, staticRenderFns } from "./eventAddCertificatePopupComponent.vue?vue&type=template&id=462af2a1&"
import script from "./eventAddCertificatePopupComponent.vue?vue&type=script&lang=ts&"
export * from "./eventAddCertificatePopupComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports